import { create } from 'zustand';

interface CheckpointState {
  // Checkpoint the character is currently standing in (opens the info card)
  activeId: string | null;
  setActiveId: (id: string | null) => void;

  // Every checkpoint the visitor has discovered this session
  visitedIds: string[];
  markVisited: (id: string) => void;

  // Nearest checkpoint hint for the HUD
  nearestId: string | null;
  nearestDistance: number;
  setNearest: (id: string | null, distance: number) => void;
}

export const useCheckpointStore = create<CheckpointState>((set) => ({
  activeId: null,
  setActiveId: (id) => set({ activeId: id }),

  visitedIds: [],
  markVisited: (id) =>
    set((state) =>
      state.visitedIds.includes(id)
        ? state
        : { visitedIds: [...state.visitedIds, id] }
    ),

  nearestId: null,
  nearestDistance: Infinity,
  setNearest: (id, distance) => set({ nearestId: id, nearestDistance: distance }),
}));
